import { render, staticRenderFns } from "./SampleTable.vue?vue&type=template&id=3c59ad80"
import script from "./SampleTable.vue?vue&type=script&lang=js"
export * from "./SampleTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports